<div class="w-full flex flex-col gap-[6px]">
    <span class="font-[800] text-[14px] text-[#6B7280]">{{ label }}</span>
  <div class="relative w-full" appClickOutside (clickOutside)="close()">
    <div
      (click)="disabled ? null : open()" [ngClass]="value ? 'text-[#374151]' : placeholder ? 'text-[#6B7280]' : ''"
      class="w-full h-[52px] {{disabled ? 'bg-gray-200 cursor-not-allowed' : 'bg-[#fff] cursor-pointer'}} border {{ dropdownOpen ? 'border-[#081A46]' : 'border-gray-300'}} {{error ? 'border-[#FF0000]' : 'border-gray-300' }} rounded-[10px] font-[400] text-[14px] flex justify-between items-center px-[13px]"
    >
      <span>{{ value ? value : placeholder }}</span> <img src="../../../assets/icons/chevron.svg" alt="">
    </div>
    <div
      *ngIf="dropdownOpen"
      class="w-full max-h-[150px] bg-[#fff] shadow-md rounded-b-[8px] overflow-y-auto absolute z-[50]"
    >
      <div *ngFor="let item of items" class="flex flex-col gap-[5px]">
        <span (click)="setItem(item)" class="hover:bg-slate-100 text-[14px] text-[#374151] font-[400] cursor-pointer py-[10px] px-[12px]">{{ item }}</span>
      </div>
    </div>
  </div>
  <span class="text-[10px] text-[#FF0000] font-[400] h-[16px]">{{ error }}</span>
</div>

